import { tokens } from "../../tokens";

/**
 * MuiButton – global control: use theme.palette so light/dark mode work.
 * Custom variant "soft" for secondary-style buttons.
 */
export const MuiButtonOverrides = {
  defaultProps: {
    disableElevation: true,
    disableRipple: false,
  },
  styleOverrides: ({ theme }) => ({
    root: {
      textTransform: "none",
      borderRadius: tokens.radius.md,
      fontFamily: tokens.typography.fontFamily,
      fontWeight: tokens.typography.fontWeight.medium,
    },
    containedPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    containedSecondary: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
        borderColor: theme.palette.text.secondary,
      },
    },
    outlinedPrimary: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      "&:hover": {
        borderColor: theme.palette.primary.dark,
        backgroundColor: theme.palette.primary.light,
      },
    },
    textPrimary: {
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
  }),
  variants: [
    {
      props: { variant: "soft" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.mode === "dark" ? theme.palette.action.hover : tokens.colors.gray100,
        color: theme.palette.text.primary,
        "&:hover": {
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.action.selected : tokens.colors.gray200,
        },
      }),
    },
  ],
};
